import axios from "axios";
import { toast } from "react-toastify";
import { config } from "./axiosconfig";
import { base_url } from "./baseUrl";

let pageData = {
  pageSize: 100,
  pageNumber: 1,
};

/**
 * Built per call, not once at module load.
 *
 * This was previously a module-level `const requestConfig = { ...config }`.
 * Spreading `config` copies `headers` by value, so the auth header was
 * snapshotted when this module was first imported — i.e. before login — and
 * every request through these helpers kept sending that stale header,
 * returning 401 after sign-in. Calling it per request re-reads the token
 * cookie (see authHeaders in ./axiosconfig).
 */
const buildRequestConfig = () => {
  const requestConfig = { headers: config.headers };

  if (pageData && pageData.pageSize && pageData.pageNumber) {
    requestConfig.params = {
      pageSize: pageData.pageSize,
      pageNumber: pageData.pageNumber,
      display: 1
    };
  }

  return requestConfig;
};

// Common function for the get APIs
const fetchData = async (endPoint) => {
  try {
    const response = await axios.get(`${base_url}${endPoint}`, buildRequestConfig());
    return response.data;
  } catch (error) {
    console.log(error);
    toast.error("Hold your breath, something went Wrong !!");
  }
};

// Common function for the get Hotmeal based on the child APIs
const fetchHotMealData = async (endPoint, childId) => {
  try {
    const response = await axios.get(
      `${base_url}${endPoint}?child=${childId}`,
      buildRequestConfig(),
    );
    return response.data;
  } catch (error) {
    console.log(error);
    toast.error("Hold your breath, something went Wrong !!");
  }
};

// common function to get the data by id
const fetchDataById = async (endPoint, id) => {
  try {
    const response = await axios.get(
      `${base_url}${endPoint}/${id}?display=1`,
      buildRequestConfig()
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }

};

// Common function to get the category menu data by id
const fetchCategoryMenuDataById = async (endPoint, id, childId) => {
  try {
    const response = await axios.get(
      `${base_url}${endPoint}/${id}?child=${childId}`,
      buildRequestConfig()
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }

};

// To update the user profile
const updateUserProfile = async (values) => {
  const response = await axios.patch(
    `${base_url}updateUserProfile`,
    values,
    config
  );
  return response.data;
};

// To Send and Resend the OTP on fogot password page.
const sendOtp = async (data) => {
  const response = await axios.post(`${base_url}auth/forgot-password`, data);
  return response;
};

// To get the schools lists
// `config` was being passed in axios's *data* position, i.e. sent as the
// request body, so no Authorization header was attached at all. POST /getSchool
// is unauthenticated so it happened to work, but the shape was wrong.
const getSchools = async () => {
  const response = await axios.post(`${base_url}getSchool`, {}, config);
  return response;
};

// Was a POST. The backend only defines GET for this path
// (web.route.js:115), so a POST fell through to the catch-all and came back as
// `{"status": false, "message": "Incorrect route!"}`. Verified against the API:
// POST -> "Incorrect route!", GET -> school class data.
const getSchoolsBySchoolId = async (id) => {
  const response = await axios.get(`${base_url}getSchoolClassByschoolId/${id}`, config);
  return response;
};
const getSchoolClasses = async (id) => {
  const response = await axios.get(`${base_url}getSchoolClass`, config);
  return response;
};

// To get the total orders
const getOrders = async (data) => {
  const requestConfig = { ...config };
  if (data && data.pageSize && data.pageNumber) {
    requestConfig.params = {
      pageSize: data.pageSize,
      pageNumber: data.pageNumber,
      end: data.endDate || "",
      start: data.startDate || "",
    };
  }
  // if (data && data.startDate && data.endDate) {
  //     requestConfig.params = {
  //         end: data.endDate || '',
  //         start: data.startDate || '',
  //     }
  // }

  try {
    const response = await axios.get(`${base_url}getOrdersList`, requestConfig);
    return response;
  } catch (error) {
    console.log(error, "error");
    return error.response;
  }
};

// To get the total Transactions
const getTransactions = async (data) => {
  const requestConfig = { ...config };
  if (data && data.pageSize && data.pageNumber) {
    requestConfig.params = {
      pageSize: data.pageSize,
      pageNumber: data.pageNumber,
      end: data.endDate || "",
      start: data.startDate || "",
    };
  }
  // if (data && data.startDate && data.endDate) {
  //     requestConfig.params = {
  //         end: data.endDate || '',
  //         start: data.startDate || '',
  //     }
  // }

  try {
    const response = await axios.get(
      `${base_url}transaction/getlist`,
      requestConfig
    );
    return response;
  } catch (error) {
    console.log(error, "error");
    return error.response;
  }
};

// for adding the order in backend.
const addOrder = async (data) => {
  try {
    const response = await axios.post(`${base_url}addOrder`, data, config);
    return response;
  } catch (error) {
    return error.response;
  }
};

//for canceling the order

const cancelOrder = async (id, cancleMessage) => {
  try {
    const response = await axios.patch(
      `${base_url}cancelOrder/${id}`,
      { cancleMessage },
      config
    );
    return response;
  } catch (error) {
    console.log(error, "error");
    return error.response;
  }
};

//for allow canceling the order

const allowCancelOrder = async (id) => {
  try {
    const response = await axios.patch(
      `${base_url}allowcancelOrder/${id}`,
      {},
      config
    );
    return response;
  } catch (error) {
    console.log(error, "error");
    return error.response;
  }
};

// Adding the transaction
const addTransaction = async (data) => {
  try {
    let obj = {
      amount: String(data.amount),
    };
    const response = await axios.post(
      `${base_url}transaction/add`,
      obj,
      config
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

// create Payments in Quick Pay

const createPayment = async (data) => {
  try {
    const response = await axios.post(
      `${base_url}quickpay/initPayment`,
      data,
      config
    );
    return response.data;
  } catch (error) {
    console.error(error.response);
    return error.response;
  }
};

// funtion for the 3-D secure in quick pay
const get3DSecureUrl = async (data) => {
  try {
    const response = await axios.post(
      `${base_url}transaction/create_payment_3d`,
      data,
      config
    );
    return response.data;
  } catch (error) {
    console.error(error.response);
    return error.response;
  }
};

// Authorize payment in quick pay
const authorizePayment = async (data, cardData, amount) => {
  try {
    const bodyData = {
      payment_id: data?.data?.id,
      amount: String(amount),
      number: String(cardData.number),
      expiry: String(cardData.expiry),
      cvv: String(cardData.cvc),
    };
    const response = await axios.post(
      `${base_url}quickpay/authorizePayment`,
      bodyData,
      config
    );
    return response;
  } catch (error) {
    return error.response;
  }
};

// function to capture payments
const capturePayment = async (data, amount) => {
  try {
    const id = data?.data?.data?.id;
    const bodyData = {
      payment_id: id,
      amount: String(amount),
    };
    const response = await axios.post(
      `${base_url}quickpay/capturePayment`,
      bodyData,
      config
    );
    return response;
  } catch (error) {
    return error.response;
  }
};

// function after payment success store transection history
const storeTransaction = async (data, orderId) => {
  try {
    const bodyData = {
      transactionId: data?.data?.data?.id,
    };
    const response = await axios.put(
      `${base_url}transaction/update/${orderId}`,
      bodyData,
      config
    );
    return response;
  } catch (error) {
    return error.response;
  }
};

// function for changing the signed in user password
const changePassword = async (data) => {
  try {
    const response = await axios.put(
      `${base_url}auth/update-password`,
      data,
      config
    );
    return response;
  } catch (error) {
    return error.response;
  }
};

// Function to resend the OTP for the users verification.
const reSendOtp = async (email) => {
  try {
    let obj = {
      email: email,
    };
    const response = await axios.post(
      `${base_url}auth/resend-otp`,
      obj,
      config
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
}

// function to send emails

const sendCustomMail = async ({ childDetails, values }) => {
  const { childName, schoolName, className } = childDetails;

  const emailContent = `<!DOCTYPE html>
  <html lang="en">
  <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Email Template</title>
      <style>
          body {
              font-family: Arial, sans-serif;
          }
          .container {
              margin: 20px;
          }
          .label {
              font-weight: bold;
          }
          .value {
              margin-bottom: 10px;
          }
      </style>
  </head>
  <body>
      <div class="container">
          <p><span class="label">Purpose of Inquiry: </span> ${values.option}</p>
          <p><span class="label">Name:</span> ${values?.name}</p>
          <p><span class="label">Email Address:</span> <a href="mailto:${values.email}">${values.email}</a></p>
          ${values.option === 'child' && childDetails
      ? `<p><span class="label">Child Name:</span> ${childName}</p>
                 <p><span class="label">School Name:</span> ${schoolName}</p>
                 <p><span class="label">Class:</span> ${className}</p>`
      : ''
    }
          <p class="value">${values.message}</p>
      </div>
  </body>
  </html>
  `
  const obj = {
    email: 'onlineskolemad@hotmail.com', // replace email with desired email
    subject: 'Inquery Mail',
    message: emailContent
  };
  const response = await axios.post(`${base_url}sendemailWtLogin`, obj).then((res) => {
    return res;
  }).catch((err) => {
    console.log(err, 'err');
  })

}

const getPageContent = async (id) => {
  const response = await axios.get(`${base_url}getPageById/${id}`, config);
  return response?.data;
}

// Terms.jsx called `commonFunction.getPagesByTitle(...)`, which was never
// defined — the resulting TypeError was swallowed by its try/catch, so the
// page silently rendered with no body content at all. This is the real
// implementation, matching the backend's GET /getPageByTitle/:title.
const getPageByTitle = async (title) => {
  const response = await axios.get(
    `${base_url}getPageByTitle/${encodeURIComponent(title)}`,
    config
  );
  return response?.data;
}

// Function to get the order by id
const getOrderById = async (id) => {
  try {
    const response = await axios.get(`${base_url}getOrderdetailsbyId/${id}`, config);
    return response?.data;
  } catch (error) {
    console.log(error, "error");
    return error.response;
  }
}

// Update the placed order befor 6 AM
const updateOrder = async (data, id) => {
  try {
    const response = await axios.post(`${base_url}updateOrder/${id}`, data, config);
    return response?.data;
  } catch (error) {
    return error.response;
  }
}

const commonFunction = {
  updateUserProfile,
  sendOtp,
  getSchools,
  getOrders,
  getTransactions,
  addOrder,
  cancelOrder,
  addTransaction,
  createPayment,
  authorizePayment,
  capturePayment,
  storeTransaction,
  fetchData,
  fetchDataById,
  changePassword,
  reSendOtp,
  sendCustomMail,
  getPageContent,
  getPageByTitle,
  get3DSecureUrl,
  getSchoolsBySchoolId,
  getSchoolClasses,
  updateOrder,
  getOrderById,
  allowCancelOrder,
  fetchHotMealData,
  fetchCategoryMenuDataById,
};

export default commonFunction;
